function StepWizard({
  stepInfo,
  currentStep,
}: {
  stepInfo: any;
  currentStep: number;
}) {
  return (
    <ol className="items-center max-w-[930px] min-[900px]:px-[50px] px-[30px] w-full mb-8 justify-center mx-auto min-[600px]:flex hidden">
      {stepInfo.map((item, index) => {
        const stepNumber = index + 1;
        const isLastStep = stepNumber === stepInfo.length;
        const isCurrentStep = stepNumber === currentStep;
        const isCompletedStep = stepNumber < currentStep;

        return (
          <div
            className={`flex flex-col ${
              isLastStep ? "" : "max-w-[200px]  w-full"
            }`}
            key={item.label}
          >
            <li
              className={`flex items-center ${
                isLastStep
                  ? ""
                  : "after:content-[''] after:w-full after:h-[2px] after:inline-block "
              } ${
                isCompletedStep ? "after:bg-black" : "after:bg-gray-300"
              } transition-all duration-300`}
            >
              <span
                className={`flex items-center justify-center w-10 h-10 rounded-full border shrink-0 relative transition-all duration-300 ${
                  isCompletedStep
                    ? "bg-gray-800 text-gray-300 border-gray-800"
                    : isCurrentStep
                      ? "bg-gray-300 text-gray-600 border-gray-600"
                      : "bg-gray-100 text-gray-400 border-gray-300"
                }`}
              >
                {item?.stepElement || <p>0{stepNumber}</p>}
                <p
                  className={`max-w-max absolute min-[900px]:-bottom-[30px] -bottom-[50px] left-2/4 text-center min-[900px]:whitespace-nowrap -translate-x-2/4 text-sm transition-all duration-300 ${
                    isCompletedStep
                      ? "text-gray-700"
                      : isCurrentStep
                        ? "text-black"
                        : "text-gray-400"
                  }`}
                >
                  {item.label}
                </p>
              </span>
            </li>
          </div>
        );
      })}
    </ol>
  );
}

export default StepWizard;
